import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchLocations = params => api.request(1, '/locations', MethodType.GET, params)

export const fetchLocationByIds = (id, params) => api.request(1, `/getLocationsById/${id}`, MethodType.GET, params)

export const delLocations = (id, params) => api.request(1, `/locations/${id}`, MethodType.DELETE, params)

export const addLocation = params => api.request(1, '/locations', MethodType.POST, params)

export const bulkAddLocation = params => api.request(1, '/addLocations', MethodType.POST, params)

export const modLocation = (id, params) => api.request(1, `/locations/${id}`, MethodType.PUT, params)

export const getGeoByAddress = params => api.request(1, '/getGeoLocation', MethodType.GET, params)

export const fetchLocationTags = params => api.request(1, '/locationTags', MethodType.GET, params)

export const bulkAddLocationTags = params => api.request(1, '/addLocationTags', MethodType.POST, params)
